import React from 'react';
import {
  Card,
  List,
  CardHeader,
  CardContent,
  Skeleton,
  createStyles,
  makeStyles,
} from '@bb-ui/react-library';

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      borderRadius: 12,
      border: '1px solid rgba(0, 0, 0, 0.08)',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.04), 0 1px 2px rgba(0, 0, 0, 0.06)',
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column' as const,
    },
    header: {
      padding: '12px 16px 8px',
      '& .MuiCardHeader-title': {
        fontSize: '13px',
        fontWeight: 600,
        textTransform: 'uppercase' as const,
        letterSpacing: '0.5px',
        color: 'rgba(0, 0, 0, 0.45)',
      },
      '& .MuiCardHeader-subheader': {
        fontSize: '12px',
        marginTop: 2,
        color: 'rgba(0, 0, 0, 0.45)',
      },
    },
    content: {
      padding: '0 8px 8px',
      flex: 1,
      '&:last-child': {
        paddingBottom: 8,
      },
    },
    list: {
      padding: 0,
    },
  }),
);

export interface JobCardListProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  headerAction?: React.ReactNode;
  loading?: boolean;
}

export const JobCardList: React.FC<JobCardListProps> = (props) => {
  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <CardHeader
        title={props.title}
        action={props.headerAction}
        subheader={props.subtitle}
        className={classes.header}
      />
      <CardContent className={classes.content}>
        <List className={classes.list}>
          {props.loading ? (
            <div>
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
              <Skeleton animation="wave" />
            </div>
          ) : (
            props.children
          )}
        </List>
        {props.actions}
      </CardContent>
    </Card>
  );
};
